import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-667d9474"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "features",
  class: "py-5"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-5" }, "Warum unseren OKR-Checker nutzen?", -1))
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "card h-100" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "d-flex justify-content-center text-primary-custom m-3" }
const _hoisted_8 = { class: "text-center m-3" }
const _hoisted_9 = { class: "card-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.usps, (usp) => {
          return (_openBlock(), _createElementBlock("div", {
            key: usp.title,
            class: "col-md-6 col-lg-4 mb-4",
            "data-aos": "fade-up"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: usp.icon,
                    size: "2x"
                  }, null, 8, ["icon"])
                ]),
                _createElementVNode("h3", _hoisted_8, _toDisplayString(usp.title), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(usp.description), 1)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}